/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmployeeRequest
 */
export interface CreateEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    accessPin: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeRequest
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeRequest
     */
    posAccess: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeRequest
     */
    tillEnabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmployeeRequest
     */
    privileges: Array<CreateEmployeeRequestPrivilegesEnum>;
}


/**
 * @export
 */
export const CreateEmployeeRequestPrivilegesEnum = {
    ProductManager: 'PRODUCT_MANAGER',
    CashDrawer: 'CASH_DRAWER',
    RealTimeReporter: 'REAL_TIME_REPORTER',
    DeliveryManager: 'DELIVERY_MANAGER',
    DiscountManager: 'DISCOUNT_MANAGER',
    TillManager: 'TILL_MANAGER',
    ShiftManager: 'SHIFT_MANAGER',
    OpenProductsCreator: 'OPEN_PRODUCTS_CREATOR',
    CloseTabAsManager: 'CLOSE_TAB_AS_MANAGER',
    BilledProductRemoval: 'BILLED_PRODUCT_REMOVAL',
    KitchenProductRemoval: 'KITCHEN_PRODUCT_REMOVAL'
} as const;
export type CreateEmployeeRequestPrivilegesEnum = typeof CreateEmployeeRequestPrivilegesEnum[keyof typeof CreateEmployeeRequestPrivilegesEnum];


/**
 * Check if a given object implements the CreateEmployeeRequest interface.
 */
export function instanceOfCreateEmployeeRequest(value: object): value is CreateEmployeeRequest {
    if (!('accessPin' in value) || value['accessPin'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('posAccess' in value) || value['posAccess'] === undefined) return false;
    if (!('tillEnabled' in value) || value['tillEnabled'] === undefined) return false;
    if (!('privileges' in value) || value['privileges'] === undefined) return false;
    return true;
}

export function CreateEmployeeRequestFromJSON(json: any): CreateEmployeeRequest {
    return CreateEmployeeRequestFromJSONTyped(json, false);
}

export function CreateEmployeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accessPin': json['accessPin'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'posAccess': json['posAccess'],
        'tillEnabled': json['tillEnabled'],
        'privileges': json['privileges'],
    };
}

export function CreateEmployeeRequestToJSON(json: any): CreateEmployeeRequest {
    return CreateEmployeeRequestToJSONTyped(json, false);
}

export function CreateEmployeeRequestToJSONTyped(value?: CreateEmployeeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessPin': value['accessPin'],
        'name': value['name'],
        'email': value['email'],
        'posAccess': value['posAccess'],
        'tillEnabled': value['tillEnabled'],
        'privileges': value['privileges'],
    };
}

